import React from 'react'
import { reduxForm } from 'redux-form'

// import OccupancyFilterSelect from './elements/OccupancyFilterSelect'

const FiltersForm = props => {
  // const {
  //   groupAvailData,
  // } = props

  return (
    <form className="bk-flow-room__filters-form">
        {/*<OccupancyFilterSelect*/}
        {/*  configData={configData}*/}
        {/*  groupAvailData={groupAvailData}*/}
        {/*/>*/}
    </form>
  )
}

export default reduxForm({
  destroyOnUnmount: false,
  keepDirtyOnReinitialize: true
})(FiltersForm)


// WEBPACK FOOTER //
// ./src/components/forms/filtersForm/FiltersForm.js